import React, { useState, useEffect } from "react";
import axios from "axios";
import constants from "../../../services/constants";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/DashboardStyle.module.css';
import DashboardTitle from "../DashboardTitle";
import DashBoardLeftProfileMenu from "../DashBoardLeftProfileMenu";
import { getUserBussinessListFormData,getJobstypeDashboardData, createJobsForBusniess, getJobsListIdFormData, getJobsUpdateFormData } from "../../../services/routes.services";
import { useNavigate, useLocation } from 'react-router-dom';
import { AiOutlinePlusCircle } from "react-icons/ai";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '../../Styles/Button.module.css';
import { useSelector } from 'react-redux';

const MyJobsCreate = () => {
    const location = useLocation();
    const jobDetails = location.state?.jobDetails || {};
    console.log(jobDetails)
    const [jobRoll, setJobRoll] = useState(jobDetails.jobRole || "");
    const [getJobType, setGetjobType] = useState( "");
    const [jobSkills, setJobSkills] = useState(jobDetails.skills || []);
    const [companyEmail, setCompanyEmail] = useState(jobDetails.email || "");
    const [jobDescription, setJobDescription] = useState(jobDetails.description || "");
    const [selectedJobType, setSelectedJobType] = useState(jobDetails.jobType || "");
    const [jobExperience, setJobExperience] = useState(jobDetails.experience || "");
    const [selectedCompany, setSelectedCompany] = useState(jobDetails.companyName || "");

    const [getAllData, setGetAllData] = useState(null);
    const { token,user } = useSelector((state) => state.auth);

    const [validationErrors, setValidationErrors] = useState({
        jobRoll: '',
        companyEmail: '',
        jobSkills: '',
        jobType: '',
        jobExperience: '',
        selectedCompany: '',
        jobDescription: ''
    });

    useEffect(() => {
        getUserBussinessListFormData(token)
            .then((res) => {
                setGetAllData(res.data.business);
            })
            .catch((error) => {
                console.log(error);
            });
            getJobstypeDashboardData() .then((res) => {
                setGetjobType(res.data.jobtype);
            })
            .catch((error) => {
                console.log(error);
            });
        getJobsListIdFormData(jobDetails._id)
            .then((res) => {
                console.log(res.data.job[0],"ssss")
                setJobRoll(res.data.job[0].jobRole);
                setJobSkills(res.data.job[0].skills);
                setCompanyEmail(res.data.job[0].email);
                setJobDescription(res.data.job[0].description);
                setSelectedJobType(res.data.job[0].jobType);
                setJobExperience(res.data.job[0].experience);
                setSelectedCompany(res.data.job[0].companyId);
            })
            .catch((error) => {
                console.log(error);
            });

    }, []);

    const navigate = useNavigate();

    const handleAddCompany = () => {
        navigate('/business-directory-create');
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const validateForm = () => {
        let valid = true;
        const errors = {
            jobRoll: '',
            companyEmail: '',
            jobSkills: '',
            jobType: '',
            jobExperience: '',
            selectedCompany: '',
            jobDescription: ''
        };

        if (!jobRoll) {
            errors.jobRoll = 'Job role is required';
            valid = false;
        }

        if (!companyEmail) {
            errors.companyEmail = 'Company email is required';
            valid = false;
        } else if (!/\S+@\S+\.\S+/.test(companyEmail)) {
            errors.companyEmail = 'Invalid email address';
            valid = false;
        }

        if (jobSkills.length === 0) {
            errors.jobSkills = 'Skills are required';
            valid = false;
        }

        if (!selectedJobType) {
            errors.jobType = 'Job type is required';
            valid = false;
        }

        if (!jobExperience) {
            errors.jobExperience = 'Experience is required';
            valid = false;
        }

        if (!selectedCompany) {
            errors.selectedCompany = 'Company selection is required';
            valid = false;
        }

        if (!jobDescription) {
            errors.jobDescription = 'Job description is required';
            valid = false;
        }

        setValidationErrors(errors);
        return valid;
    };

    const handleJobAddSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            var formData = new FormData();
            formData.append('company', selectedCompany);
            formData.append('email', companyEmail);
            formData.append('jobRole', jobRoll);
            formData.append('skills', jobSkills);
            formData.append('jobType', selectedJobType);
            formData.append('experience', jobExperience);
            formData.append('description', jobDescription);
            formData.append('user', user._id);

            let response;
            if (Object.keys(jobDetails).length !== 0) {
                // Update existing job
                response = await getJobsUpdateFormData(jobDetails._id, formData,token);
            } else {
                // Create new job
                response = await createJobsForBusniess(formData,token);
            }

            if (response.status === 200 || response.status === 201 || response.success === true) {
                const action = Object.keys(jobDetails).length !== 0 ? 'updated' : 'added';
                toast.success(`Job ${action} successfully!`, {
                    position: "top-right",
                    autoClose: 2000,
                    type: 'success'
                });
                navigate(-1); // Navigate back
            } else {
                const action = Object.keys(jobDetails).length !== 0 ? 'updated' : 'added';
                toast.success(`Job ${action} successfully!`, {
                    position: "top-right",
                    autoClose: 2000,
                    type: 'success'
                });
                navigate(-1); // Navigate back
            }
        } catch (error) {
            console.error(`Error ${Object.keys(jobDetails).length !== 0 ? 'updating' : 'adding'} job:`, error);
            toast.error(`An error occurred while ${Object.keys(jobDetails).length !== 0 ? 'updating' : 'adding'} the job.`, {
                position: "top-right",
                type: 'error'
            });
        }
    };

    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla ' + Style.Dashboardscreen + " " + Style.BussinesList}>
                <Container>
                    <DashboardTitle title="Jobs Listing" membertype="Non Member" />
                    <Row className={Style.space}>
                        <Col>
                            <div className={Style.newFormStyle}>
                                <h3 className={Style.dashboardSubTitle}>ADD JOB DETAILS</h3>
                                <form onSubmit={handleJobAddSubmit} id="myform" method="post" noValidate>
                                    <div className={Style.formContainer}>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Company</label>
                                                <select className={Style.inputStyle} value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
                                                    <option>Select Business Directory</option>
                                                    {getAllData && getAllData.map((BinessName) => (
                                                        
                                                        <option key={BinessName._id} value={BinessName._id}>{BinessName.name}</option>
                                                    ))}
                                                </select>
                                                {validationErrors.selectedCompany && <span className={Style.error}>{validationErrors.selectedCompany}</span>}
                                            </div>
                                            <div className={Style.addCol}>
                                                <button type="button" className={Button.greenBtn + ' ' + Button.greenBtn} onClick={handleAddCompany}><AiOutlinePlusCircle /> ADD COMPANY</button>
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Jobs/careers Email Id</label>
                                                <input type='text' className={Style.inputStyle} value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
                                                {validationErrors.companyEmail && <span className={Style.error}>{validationErrors.companyEmail}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Job Role</label>
                                                <input className={Style.inputStyle} type='text' value={jobRoll} onChange={(e) => setJobRoll(e.target.value)} />
                                                {validationErrors.jobRoll && <span className={Style.error}>{validationErrors.jobRoll}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Skills</label>
                                                <input type='text' className={Style.inputStyle} value={jobSkills} onChange={(e) => setJobSkills(e.target.value)} />
                                                {validationErrors.jobSkills && <span className={Style.error}>{validationErrors.jobSkills}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Type of Job</label>
                                                <select className={Style.inputStyle} value={selectedJobType} onChange={(e) => setSelectedJobType(e.target.value)}>
                                                    <option>Select Type of Job</option>
                                                    {getJobType && getJobType.map((jobtype)=>{
                                                        return(
                                                        <option key={jobtype._id} value={jobtype._id}>{jobtype.name}</option>
                                                        )
                                                    })}
                                                </select>
                                                {validationErrors.jobType && <span className={Style.error}>{validationErrors.jobType}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Experience</label>
                                                <select className={Style.inputStyle} value={jobExperience} onChange={(e) => setJobExperience(e.target.value)}>
                                                    <option>Select Experience</option>
                                                    <option value="0-1 Yrs">0-1 Yrs</option>
                                                    <option value="1-2 Yrs">1-2 Yrs</option>
                                                    <option value="2-3 Yrs">2-3 Yrs</option>
                                                    <option value="3-4 Yrs">3-4 Yrs</option>
                                                    <option value="4-5 Yrs">4-5 Yrs</option>
                                                    <option value="5-6 Yrs">5-6 Yrs</option>
                                                    <option value="6-7 Yrs">6-7 Yrs</option>
                                                    <option value="7-8 Yrs">7-8 Yrs</option>
                                                    <option value="8-9 Yrs">8-9 Yrs</option>
                                                    <option value="9-10 Yrs">9-10 Yrs</option>
                                                    <option value="10-11 Yrs">10-11 Yrs</option>
                                                    <option value="11-12 Yrs">11-12 Yrs</option>
                                                    <option value="12-13 Yrs">12-13 Yrs</option>
                                                    <option value="13-14 Yrs">13-14 Yrs</option>
                                                    <option value="15+ Yrs">15+ Yrs</option>
                                                </select>
                                                {validationErrors.jobExperience && <span className={Style.error}>{validationErrors.jobExperience}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2}>
                                                {console.log(jobDescription)}
                                                <label>Job Description</label>
                                                <textarea type='text' className={Style.inputStyle} value={jobDescription} onChange={(e) => setJobDescription(e.target.value)} ></textarea>
                                                {validationErrors.jobDescription && <span className={Style.error}>{validationErrors.jobDescription}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2 + ' ' + Style.fromBtn}>
                                                <button type="submit" className={Style.subBtn}>Submit</button>
                                                <button type="button" onClick={handleCancel} className={Style.clearBtn}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Col>
                    </Row>
                    <ToastContainer />
                </Container>
            </div>
        </div>
    );
};

export default MyJobsCreate;
